import React, { Component } from 'react';
import * as d3 from 'd3';
import './parliament.css';

class ChartParliament extends Component {
	constructor(props) {
		super(props);
		
		this.draw = this.draw.bind( this );
		this.format = this.format.bind( this );
		
		this.state = {
			"arcs": {
				"sinistra": null,
				"centro-sinistra": null,
				"m5s": null,
				"centro-destra": null,
				"destra": null,
				"border": null
			},
			"loading": true
		}
	}
	
	componentDidUpdate( prevProps, prevState ) {
		if ( prevProps.DrawingData !== this.props.DrawingData && this.props.DrawingData.ready) {
			this.draw();
		}
	}
	
	format( percent ) {
		 return (percent * 100).toLocaleString();
	}
	
	draw() {
		let innerRadius = 40;
		let outerRadius = 160;
		let startAngle = -Math.PI / 2;
		
		var arc = d3.arc();
		var endAngle = startAngle + (Math.PI * this.props.DrawingData['sinistra'].percent);
		var sinistra = arc({
		  innerRadius: innerRadius,
		  outerRadius: outerRadius,
		  startAngle: startAngle,
		  endAngle: endAngle
		});
		endAngle = endAngle + (Math.PI * this.props.DrawingData['centro-sinistra'].percent);
		var centroSinistra = arc({
		  innerRadius: innerRadius,
		  outerRadius: outerRadius,
		  startAngle: startAngle,
		  endAngle: endAngle
		});
		endAngle = endAngle + (Math.PI * this.props.DrawingData['m5s'].percent);
		var m5s = arc({
		  innerRadius: innerRadius,
		  outerRadius: outerRadius,
		  startAngle: startAngle,
		  endAngle: endAngle
		});
 		endAngle = endAngle + (Math.PI * this.props.DrawingData['centro-destra'].percent);
		var centroDestra = arc({
		  innerRadius: innerRadius,
		  outerRadius: outerRadius,
		  startAngle: startAngle,
		  endAngle: endAngle
		});
		var destra = arc({
		  innerRadius: innerRadius,
		  outerRadius: outerRadius,
		  startAngle: startAngle,
		  endAngle: Math.PI / 2
		});
		
		this.setState( {
			"loading": false,
			"arcs": {
				"sinistra": sinistra,
				"centro-sinistra": centroSinistra,
				"m5s": m5s,
				"centro-destra": centroDestra,
				"destra": destra,
				"border": destra
			}
		} );
		
	}
	
	render() {
		return (
			<div className="chart-parliament" id={"chart-parliament-" + this.props.ChartId}>
				
					<svg className="chart-parliament-viz" preserveAspectRatio="xMidYMid meet"viewBox="0 0 400 200">
						<g className="chart-parliament-arcs">
							<path className="chart-parliament-arc chart-parliament-destra" d={this.state.arcs['destra']} />
							<path className="chart-parliament-arc chart-parliament-centro-destra" d={this.state.arcs['centro-destra']} />
							<path className="chart-parliament-arc chart-parliament-m5s" d={this.state.arcs['m5s']} />
							<path className="chart-parliament-arc chart-parliament-centro-sinistra" d={this.state.arcs['centro-sinistra']} />
							<path className="chart-parliament-arc chart-parliament-sinistra" d={this.state.arcs['sinistra']} />
						</g>
						<g className="chart-parliament-borders">
							<line className="chart-parliament-base" x1="-50%" y1="0" x2="50%" y2="0" strokeWidth="4" stroke="#ccc" />
							<path className="chart-parliament-border" d={this.state.arcs.border} fill="transparent" strokeWidth="4" stroke="#ccc" />
							<line className="chart-parliament-base" x1="-50%" y1="0" x2="50%" y2="0" strokeWidth="4" stroke="#ccc" />
							<circle className="chart-parliament-hole" cx="0" cy="0" r="39" fill="#fff" />
						</g>
					</svg>
					<div className="chart-parliament-legend">
						<ul>
							<li className="chart-parliament-legend-item sinistra"><a href="#/categoria/sinistra" className=" ">Sinistra</a> — {( ( this.props.DrawingData && this.props.DrawingData['sinistra'] ) ? this.format( this.props.DrawingData['sinistra'].percent ) : "" )}%</li>
							<li className="chart-parliament-legend-item centro-sinistra"><a href="#/categoria/centro-sinistra" className=" ">Centro Sinistra</a> — {( ( this.props.DrawingData && this.props.DrawingData['centro-sinistra'] ) ? this.format( this.props.DrawingData['centro-sinistra'].percent ) : "" )}%</li>
							<li className="chart-parliament-legend-item m5s"><a href="#/categoria/m5s" className=" ">Movimento 5 Stelle</a> — {( ( this.props.DrawingData && this.props.DrawingData['m5s'] ) ? this.format( this.props.DrawingData['m5s'].percent ) : "" )}%</li>
							<li className="chart-parliament-legend-item centro-destra"><a href="#/categoria/centro-destra" className="">Centro Destra</a> — {( ( this.props.DrawingData && this.props.DrawingData['centro-destra'] ) ? this.format( this.props.DrawingData['centro-destra'].percent ) : "" )}%</li>
							<li className="chart-parliament-legend-item destra"><a href="#/categoria/destra" className=" ">Destra</a> — {( ( this.props.DrawingData && this.props.DrawingData['destra'] ) ? this.format( this.props.DrawingData['destra'].percent ) : "" )}%</li>
						</ul>
					</div>
				
			</div>
		);
	}
}

export default ChartParliament;


// WEBPACK FOOTER //
// ./src/Elezioni/charts/parliament.js